import React, { useState, useEffect } from "react";

const consejos = [
  "Aléjese de los sectores de marejadas",
  "Protégete del sol con protector solar",
  "¡Viña del Mar es una ciudad caminable, camínala!",
  "Alójate en establecimientos formales",
  "Deposita la basura en los tachos",
  "Prefiere el comercio legal",
  "Respeta las señales de tránsito y los cruces peatonales",
  "En el auto, no dejes artículos de valor",
  "Si bebes, no conduzcas"
];


function LoadingChat() {
  const [textoActual, setTextoActual] = useState("Pensando");

  useEffect(() => {

    const interval = setInterval(() => {
      const indiceAleatorio = Math.floor(Math.random() * consejos.length);
      setTextoActual(consejos[indiceAleatorio]);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-row items-center gap-[10px] justify-center">

      <div className="flex flex-row items-end gap-[2px] h-2">
        <div className="w-1.5 h-1.5 bg-[#697C81] rounded-full "
          style={{
            animation: "bounce 1s ease-in-out 0.3s infinite"
          }}
        />
        <div className="w-1.5 h-1.5 bg-[#697C81] rounded-full "
          style={{
            animation: "bounce 1s ease-in-out 0.6s infinite"
          }}
        />
        <div className="w-1.5 h-1.5 bg-[#697C81] rounded-full "
          style={{
            animation: "bounce 1s ease-in-out 0.9s infinite"
          }}
        />
      </div>

      <p key={textoActual} className="animate-fade-in text-gray-500 text-sm m-0 p-0 leading-relaxed max-w-72">
        {textoActual}
      </p>
      <style>{`
        @keyframes bounce {
          0%, 50%, 100% {
            transform: translateY(0);
          }
          30% {
            transform: translateY(-3px);
          }
        }
      `}</style>
      
    </div>
  );
}

export default LoadingChat;